import { Capacitor } from '@capacitor/core'

/**
 * Check if the app is running in a Capacitor native environment
 */
export const isCapacitor = (): boolean => {
  return Capacitor.isNativePlatform()
}

/**
 * Check if the app is running on iOS
 */
export const isIOS = (): boolean => {
  return Capacitor.getPlatform() === 'ios'
}

/**
 * Check if the app is running on Android
 */
export const isAndroid = (): boolean => {
  return Capacitor.getPlatform() === 'android'
}

/**
 * Check if the app is running in a web browser
 */
export const isWeb = (): boolean => {
  return Capacitor.getPlatform() === 'web'
}

/**
 * Get the current platform
 */
export const getPlatform = (): string => {
  return Capacitor.getPlatform()
}

/**
 * Check if native sharing capabilities are available
 */
export const hasNativeShare = (): boolean => {
  return isCapacitor() && (isIOS() || isAndroid())
}
